import { render, staticRenderFns } from "./PrescriptionOptique.vue?vue&type=template&id=f2753496&scoped=true"
var script = {}
import style0 from "./PrescriptionOptique.vue?vue&type=style&index=0&id=f2753496&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2753496",
  null
  
)

export default component.exports